// export const GSTpattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z1-9A-J]{1}[0-9A-Z]{1}$/;
export const GSTpattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{1}[0-9A-Z]{1}[0-9A-Z]{1}$/;

export const mobileNoPattern = /^[0-9]{10}$/;
export const accountNoPattern = /^[0-9A-Z]{8,17}$/;
export const pincodeNoPattern = /^[0-9]{6,9}$/;
export const ifscCodePattern = /^[0-9A-Z]{11}$/;

export const dateFormat = 'DD/MM/YYYY';
export const dateTimeFormat = 'DD/MM/YYYY  HH:mm:ss';

export const amountFormat = (amount) => {
    return parseFloat(amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}